import React from 'react'
import {Routes,Route} from 'react-router-dom'
import Home from './Home'
import About from './About'
import Teachers from './Teachers'
import Students from './Students'

import Contact from './Contact'
import Footer from '../Components/Footer'


const AllPages = () => {
  return (
    <div>
      {/* <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/teachers" element={<Teachers/>}/>
        <Route path="/students" element={<Students/>}/>
        <Route path="/contact" element={<Contact/>}/>
      </Routes> */}
    </div>
  )
}

export default AllPages